module.exports = __webpack_public_path__ + "img/lrw.40c1c7c9.jpg";